import { Injectable } from '@angular/core';
import { AuthService } from '../../services/auth.service';

import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const byPassTokenURLs = ['prospect-form', '/login', '/api/validate/'];

    const urlPattern = new RegExp(
      byPassTokenURLs
        .map((url) => url.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
        .join('|')
    );

    if (
      this.authService.userIsAuth() &&
      request.url.search(urlPattern) == -1 &&
      this.authService.isWeb()
    ) {
      const token = this.authService.getAcessToken();
      if (token) {
        request = request.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
      }

      if (
        request.url.search('/token/') == -1 &&
        this.authService.isCallRefreshToken()
      ) {
        this.authService.callRefreshToken();
      }
    }

    return next.handle(request).pipe(
      tap({
        error: (e) => {
          if (e instanceof HttpErrorResponse && e.status === 401) {
            this.authService.callRefreshToken();
          }
        },
      })
    );
  }
}
